import * as React from "react";
const SvgFiRrBong = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m23.161 7.476-3.055-2.5a1 1 0 0 0-1.407.141 1 1 0 0 0 .14 1.407l.754.617-1.425 1.742a11 11 0 0 0-2.167-1.132V2a1 1 0 1 0 0-2h-8a1 1 0 1 0 0 2v5.75a10.95 10.95 0 0 0-7 10.25c.062 3.19 2.756 6 6.004 6h9.992c3.248 0 5.942-2.806 6.004-6 0-3.04-1.226-5.836-3.282-7.853l1.423-1.739.753.616a1 1 0 0 0 1.407-.141 1 1 0 0 0-.14-1.407zM21 18c-.04 2.108-1.838 4-4.004 4H7.004C4.838 22 3.04 20.104 3 18q.002-1.03.221-2H17a1 1 0 1 0 0-2H3.928a8.96 8.96 0 0 1 5.371-4.587 1 1 0 0 0 .7-.954V2h4v6.459a1 1 0 0 0 .7.954A8.96 8.96 0 0 1 21 18"
    />
  </svg>
);
export default SvgFiRrBong;
